import { pickBy } from 'lodash';
import type { PickPrimitives } from '../../helpers/helpers.types';

/**
 * Tests whether the given input is a primitive value
 * @param  {*} test
 * @return {boolean}
 */
export const isPrimitive = (test: unknown): boolean => (test !== Object(test));

export const pickPrimitives = <T extends object>(obj: T): PickPrimitives<T> => {
  const result = pickBy(obj, (value) => isPrimitive(value)) as any;

  return result;
};
